import { featureFlagService as defaultFeatureFlagService } from '@superbet-group/web.lib.flags';
import { LDMultiKindContext } from 'launchdarkly-js-client-sdk';
import { LdContextKind } from './types';
import { getDeviceId } from '@src/config/idGenerationService';

export const ldAnonymousUserKey = localStorage.getItem('ldAnonymousUserKey') || 'UNKNOWN_ANONYMOUS_USER';

export function getDefaultMultiContext(): LDMultiKindContext {
    return {
        kind: LdContextKind.Multi,
        device: {
            kind: LdContextKind.Device,
            key: ldAnonymousUserKey,
            deviceId: getDeviceId(),
            hostname: window.location.hostname,
        },
    };
}

const LD_INITIALIZATION_TIMEOUT = 1000;
export function initializeFeatureFlagMultiContext(featureFlagService = defaultFeatureFlagService) {
    // explanation of multi-context https://www.notion.so/superbet/Launch-darkly-multi-context-128d63a01cd04e04bcbba9ef56d3a459
    // if this times out we are going to receive default values for all feature flags
    // targeted with device context

    return Promise.race([
        featureFlagService.initializeWithMultiContext(getDefaultMultiContext()),
        new Promise((resolve) => {
            setTimeout(resolve, LD_INITIALIZATION_TIMEOUT);
        }),
    ]);
}
